export default __webpack_public_path__ + "static/media/arrow_left_gray.5343b7f8.svg";